export const NO_ASSIGNEE = "**No Assignee**";
export const NO_ASSGINEE_KEY = "not_assigned";
